import styles from './Tip.css'
import { Tip } from '@vzmi/shp_shared_compo'

const CustomizeTip = props => {
  return (
    <Tip
      type='info'
      className={styles.tips}
    >
      統計近14天內(不含昨天), 導流進賣場的熱門關鍵字排行, 顯示前20名
    </Tip>
  )
}

export default CustomizeTip
